import React, {Component, createRef} from "react";
import SimpleButton from "./commons/SimpleButton";

class SimplePrintButton extends Component {
    clContentPopup = "app-menu-popup app-menu-popup-hide";
    constructor(props) {
        super(props);
        this.state = {
            profileClass: this.clContentPopup,
            openPrint: false,
        };
        this.menuRef = createRef();
    }

    handleOptionCetak = () => {
        var element = document.getElementById("app-cetak");
        element.style.display = "block";
        this.setState({
            openPrint: !this.state.openPrint,
        });
        if (!this.state.openPrint) {
            this.handleClickOutside(element);
        }
    }

    handleClickOutside(element) {
        const outsideclickListener = (event) => {
            if (!element.contains(event.target)) {
                element.style.display = "none";
                removeClickListener();
            }
        };

        const removeClickListener = () => {
            this.setState({ openPrint: false });
            document.removeEventListener("click", outsideclickListener);
        };

        document.addEventListener("click", outsideclickListener);
    }

    render() {
        const { onPrint, toPdf, toExcel } = this.props;
        return (
            <div style={{position: "relative"}}>
                <SimpleButton {...this.props} onClick={this.handleOptionCetak}/>
                <div ref={this.menuRef} id="app-cetak" className={this.state.profileClass} style={{
                    position: "absolute",
                    top: toPdf && toExcel ? "-115px" : "-75px",
                    width: "250px",
                    background: "white",
                    border: "1px solid #ccc",
                    padding: "10px"
                }}>
                    <ul style={{listStyle: "none", padding: 0}}>
                        {toExcel && (
                            <button
                                id="btn_open_cetak_excel_modal"
                                onClick={() => onPrint("excel")}
                                style={{background: "none", cursor: "pointer", textAlign: "left", width: "100%"}}
                            >
                                <li>
                                    <i className="icn fa fa-lw fa-print"></i> Export to Excel
                                </li>
                            </button>
                        )}

                        {toPdf && (
                            <button
                                id="btn_open_cetak_pdf_modal"
                                onClick={() => onPrint("pdf")}
                                style={{background: "none", cursor: "pointer", textAlign: "left", width: "100%"}}
                            >
                                <li>
                                    <i className="icn fa fa-lw fa-print"></i> Export to PDF
                                </li>
                            </button>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}

export default SimplePrintButton;